export default __webpack_public_path__ + "static/media/mode-48.bae42aaf.svg";